"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var Select_1 = __importDefault(require("./Select"));

var wallets_1 = require("../../wallets");

var react_redux_1 = require("react-redux");

var wallet_1 = require("../../actions/wallet");

var utils_1 = require("ethers/utils");

var mapStateToProps = function mapStateToProps(state) {
  var walletState = state.WalletReducer;
  return {
    accounts: walletState.get("accounts"),
    selectedAccountID: walletState.get("selectedAccountID"),
    walletTranslations: walletState.get("walletTranslations"),
    unit: walletState.get("unit"),
    decimals: walletState.get("decimals")
  };
};

var WalletSelector = function (_super) {
  __extends(WalletSelector, _super);

  function WalletSelector() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  WalletSelector.prototype.render = function () {
    var _a = this.props,
        selectedAccountID = _a.selectedAccountID,
        walletTranslations = _a.walletTranslations;
    var options = this.getOptions();
    var blankText;

    if (options.length === 0) {
      blankText = walletTranslations.noAvailableAddress;
    } else {
      blankText = walletTranslations.pleaseSelectAddress;
    }

    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: "HydroSDK-fieldGroup"
    }, React.createElement("div", {
      className: "HydroSDK-label"
    }, walletTranslations.selectAddress), React.createElement(Select_1.default, {
      blank: blankText,
      noCaret: options.length === 0,
      disabled: options.length === 0,
      options: options,
      selected: selectedAccountID || ""
    })));
  };

  WalletSelector.prototype.getOptions = function () {
    var _a = this.props,
        walletType = _a.walletType,
        dispatch = _a.dispatch,
        unit = _a.unit,
        decimals = _a.decimals;
    var options = [];
    this.getWalletAccounts(walletType).forEach(function (account, accountID) {
      var text = account.get("address");
      var isLocked = account.get("isLocked");
      var balance = account.get("balance");
      var wallet = account.get("wallet");

      if (text) {
        options.push({
          value: accountID,
          component: React.createElement("div", {
            className: "HydroSDK-address-option"
          }, React.createElement("span", null, isLocked ? React.createElement("i", {
            className: "HydroSDK-fa fa fa-lock"
          }) : React.createElement("i", {
            className: "HydroSDK-fa fa fa-check"
          }), wallets_1.truncateAddress(text)), React.createElement("span", null, balance.div(new utils_1.BigNumber(10).pow(decimals).toString()).toFixed(5), " ", unit)),
          onSelect: function onSelect(option) {
            dispatch(wallet_1.selectAccount(option.value, wallet.type()));
          }
        });
      }
    });
    return options;
  };

  WalletSelector.prototype.getWalletAccounts = function (walletType) {
    var accounts = this.props.accounts;
    return accounts.filter(function (account) {
      return account.get("wallet").type() === walletType;
    });
  };

  return WalletSelector;
}(React.PureComponent);

exports.default = react_redux_1.connect(mapStateToProps)(WalletSelector);